import { t } from '@/i18n';
import { z } from 'zod';

/// ////////////////////////////////////////////
/// Enum
/// ////////////////////////////////////////////

const managementExpenseSubsidyMonetizationStandardType = z.enum([
  'business-progress',
  'period-progress',
  'cost-progress',
]);

export const ManagementExpenseSubsidyMonetizationStandardModifier = {
  'business-progress': t('business-progress'),
  'period-progress': t('period-progress'),
  'cost-progress': t('cost-progress'),
} as const satisfies Record<
  z.infer<typeof managementExpenseSubsidyMonetizationStandardType>,
  string
>;

/// ////////////////////////////////////////////
/// Model
/// ////////////////////////////////////////////

export const SegmentExpenditureAndExecutionModel = z.object({
  id: z.string().uuid(),
  projectId: z.string().uuid(),
  fiscalYear: z.number().int(),
  revenueInitialBudgetAmount: z.number().nullish(),
  revenueSupplementary1BudgetAmount: z.number().nullish(),
  revenueSupplementary2BudgetAmount: z.number().nullish(),
  revenueSupplementary3BudgetAmount: z.number().nullish(),
  revenueSupplementary4BudgetAmount: z.number().nullish(),
  revenueSupplementary5BudgetAmount: z.number().nullish(),
  revenueManagementExpenseExecutedAmount: z.number().nullish(),
  revenueSubsidyExecutedAmount: z.number().nullish(),
  revenueOthersExecutedAmount: z.number().nullish(),
  revenueEstimatedAmountForNextYear: z.number().nullish(),
  expenditureBudgetAmount: z.number().nullish(),
  expenditureExecutedAmount: z.number().nullish(),
  revenueManagementExpenseSubsidyMonetizationStandards:
    managementExpenseSubsidyMonetizationStandardType.array().nullish(),
});

export const SegmentExpenditureAndExecutionsModel =
  SegmentExpenditureAndExecutionModel.array();

/// ////////////////////////////////////////////
/// Schema
/// ////////////////////////////////////////////

const _PreviousFiscalYearExecutedFormSchema =
  SegmentExpenditureAndExecutionModel.pick({
    revenueManagementExpenseExecutedAmount: true,
    revenueSubsidyExecutedAmount: true,
    revenueOthersExecutedAmount: true,
    expenditureExecutedAmount: true,
  });

const _CurrentFinalizedAmountFormSchema =
  SegmentExpenditureAndExecutionModel.pick({
    revenueInitialBudgetAmount: true,
    revenueSupplementary1BudgetAmount: true,
    revenueSupplementary2BudgetAmount: true,
    revenueSupplementary3BudgetAmount: true,
    revenueSupplementary4BudgetAmount: true,
    revenueSupplementary5BudgetAmount: true,
    expenditureBudgetAmount: true,
    revenueEstimatedAmountForNextYear: true,
  }).extend({
    revenueManagementExpenseSubsidyMonetizationStandards:
      managementExpenseSubsidyMonetizationStandardType.array().min(1),
  });
